/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useRecoilValue } from "recoil";
import { util } from "recoil/recoilState";
import { theme } from "styles/theme";
import IOSSwitch from "uis/iosSwitch";
import { translate } from "./translate";

const Container = styled.div`
    background-color: ${theme.neutral50};
    padding: 12px 120px;
    margin-top: 13px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
`;

const Label = styled.p`
    color: ${theme.neutral900};
    font-size: 16px;
    font-weight: 700;
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
`;

const Annotaion = styled.p`
    color: ${theme.neutral500};
    font-size: 12px;
    font-weight: 500;
`;

const PersonalVisitToggle = ({ value, onChange }: { value: boolean; onChange: () => void }) => {
    const { language } = useRecoilValue(util);

    return (
        <Container>
            <Column>
                <Label>{translate["개별 방문 활성화"][language]}</Label>
                <Annotaion>{translate["개별 방문 활성화 설명"][language]}</Annotaion>
            </Column>
            <IOSSwitch checked={value} onChange={onChange} />
        </Container>
    );
};

export default PersonalVisitToggle;
